<script setup>
import { setup } from './resetMailSendModal'

const props = defineProps({
  mailResult: {
    type: Boolean,
    required: false,
    default: false,
  },
})

const {
  // props
  modalVisible,
  // functions
  closeModal,
} = setup(props)
</script>

<template>
  <!-- Modal01 -->
  <div
    v-show="modalVisible"
    class="md_modal modal01"
  >
    <button
      v-on:click="closeModal"
      class="bgLayer js_modalX"
    ></button>
    <div class="modalSet">
      <div class="Content">
        <div class="textArea">
          <div class="catch">パスワード再発行手続き完了</div>
          <p class="copy">ご登録いただいているメールアドレスへパスワードリセット手順を送信しました。</p>
        </div>
        <div class="actionArea">
          <button
            class="md_btn md_btn--medium md_btn--second js_modalX"
            v-on:click="closeModal"
          >
            閉じる
          </button>
        </div>
      </div>
    </div>
  </div>
  <!-- /Modal01 -->
</template>
